type PreparedDate = {
  day: string
  month: string
  year: string
  hour: string
  minutes: string
  monthName: string
}

const MONTHS: string[] = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export const prepareDate = (date: Date, format: 'default' | 'UTC' = 'default'): PreparedDate => {
  const day = format === 'UTC' ? date.getUTCDate() : date.getDate()
  const month = format === 'UTC' ? date.getUTCMonth() + 1 : date.getMonth() + 1
  const year = format === 'UTC' ? String(date.getUTCFullYear()) : String(date.getFullYear())
  const hour = format === 'UTC' ? String(date.getUTCHours()) : String(date.getHours())
  const minutes = format === 'UTC' ? String(date.getUTCMinutes()) : String(date.getMinutes())

  return {
    day: day >= 10 ? String(day) : `0${day}`,
    month: month >= 10 ? String(month) : `0${month}`,
    monthName: MONTHS[month - 1]!,
    year,
    hour,
    minutes,
  }
}
